export default "__VITE_ASSET__BlEMxT8Q__"